import hoistNonReactStatics from 'hoist-non-react-statics';
import { curry } from 'ramda';

const hoistStatics = curry(
  (To, From) =>
    hoistNonReactStatics(To, From, {
      handledProps: true,
      mutated: true,
      mutation: true,
    }) as typeof From
);

export default hoistStatics;
